const e = {
  name: "Refresh",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 12C5 8.13228 8.13228 5 12 5C14.3787 5 16.4788 6.18596 17.7455 8H14V10H21V3H19V6.34344C17.3507 4.30582 14.8309 3 12 3C7.02772 3 3 7.02772 3 12C3 16.9723 7.02772 21 12 21C16.9723 21 21 16.9723 21 12H19C19 15.8677 15.8677 19 12 19C8.13228 19 5 15.8677 5 12Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as Refresh
};
